<template>
  <BlockFieldset class="project-appointment-notes">
    <p v-if="isNewProject" class="text-muted">{{ $t('saveNewProjectFirst') }}</p>
    <div v-else>
      <b-form-group
        horizontal
        :label="$t('appointmentNotes')"
        label-for="appointmentNotes"
        label-class="text-md-right"
        :label-cols="2"
        breakpoint="md"
      >
        <div id="appointmentNotes" class="dense-editor">
          <ckeditor
            :editor="editor"
            v-model="project.technicalReview.appointmentNotes"
            :config="editorConfig"
            :disabled="isBlockReadOnly"
          ></ckeditor>
        </div>
      </b-form-group>

      <div v-if="!isBlockReadOnly" class="text-right mt-2">
        <b-button variant="bg" :disabled="isSaving" @click="save">
          {{ $t('saveNamed', { name: $t('appointmentNotes') }) }}
        </b-button>
      </div>
    </div>
  </BlockFieldset>
</template>

<script>
import { mapActions } from 'vuex';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import InlineEditor from '@ckeditor/ckeditor5-build-inline';
import BlockFieldset from '@/components/Access/BlockFieldset.vue';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import { BlockSaveMixin } from '@/mixins/blockSave';
import { toProjectAppointmentNotesInput } from './projectAppointmentNotesInput';

/** Number of the unsaved project (ProjectEdit `_new`): the block needs a saved project. */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Block project-appointment-notes ("Besonderheiten bei Terminierung", see feature page
 * projekt-montage): one rich text field with the markup it had in the block "Techn. Prüfung -
 * DC". On the unsaved project it shows only a hint. Emits `dirty` and `saved`.
 */
export default {
  name: 'ProjectAppointmentNotes',
  components: { BlockFieldset, ckeditor: CKEditor.component },
  mixins: [AccessBlockMixin, BlockSaveMixin],
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
  },
  data() {
    return {
      editor: InlineEditor,
      editorConfig: {},
    };
  },
  computed: {
    isNewProject() {
      return this.project.number === NEW_PROJECT_NUMBER;
    },
    blockInput() {
      return toProjectAppointmentNotesInput(this.project);
    },
  },
  methods: {
    ...mapActions(['updateProjectAppointmentNotes']),
    saveBlockInput(input) {
      return this.updateProjectAppointmentNotes({ projectNumber: this.project.number, input });
    },
  },
};
</script>

<style scoped lang="scss">
.dense-editor {
  height: auto;
  max-height: 300px;
  overflow-y: auto;
}

.ck-editor__editable_inline {
  min-height: 110px;
  height: auto;
  max-height: 300px;
  overflow-y: auto;
}
</style>
